export interface ICardVariant {
  variant_name: string;
  v_points: number;
}

export interface ICardUserVariant extends ICardVariant {
  variant: boolean;
  index: number;
}

export type ICardResultState =
  | 'missed-correct-answer'
  | 'no-correct-answer-available'
  | 'non-positive-score'
  | 'positive-score';

export function isCardResultState(value: unknown): value is ICardResultState {
  return value === 'missed-correct-answer' ||
    value === 'no-correct-answer-available' ||
    value === 'non-positive-score' ||
    value === 'positive-score';
}

export interface ICardHumanDescription {
  text?: string;
  name?: string;
  type?: string;
  question?: string;
}

export interface ICardInfluence {
  is_mandatory?: boolean;
  other?: boolean;
  card_type?: string;
  [key: string]: unknown;
}

export interface ICardData {
  human_descrition?: ICardHumanDescription;
  influence?: ICardInfluence;
  variants_type?: string;
  variants?: ICardVariant[];
  card_points?: number;
  explanation?: string;
  userList?: ICardUserVariant[];
  [key: string]: unknown;
}

export interface ICard {
  card_id: number;
  type_id: number;
  name: string;
  active: boolean;
  level: number;
  data: ICardData;
  owner_player_id?: number;
  turn_id?: number;
  [key: string]: unknown;
}

export interface ICardResponse {
  card: ICard;
}
